import styled from 'styled-components';
import { Card } from '@widgets/shared/styles/card';
export const Wrapper = styled.div `
  input {
    display: none;
  }
  
  input:checked {
    & + label ${Card} {
      border: 0.1rem solid red;
    }
  }
`;
export const Content = styled.div `
  position: relative;
  z-index: 2;
  color: white;
  
  .btn {
    margin-top: 2rem;
    
    #fitness-page & {
      color: var(--primary-dark);
    }
  }
  
  .list--tick {
    gap: 0;
    
    li {
      // fixes for the hacky design....
      min-height: 3.5rem;
      max-height: 4rem; // allowing 20px extra beneath on 2 lines
      padding-bottom: 1.5rem; // build in margin on non 2 line list items
      
      &:last-of-type {
        padding-bottom: 0;
        min-height: 0;
      }
    }
  }
`;
export const TagWrapper = styled.div `
  margin: 1.2rem 0;
  
  .tag {
    margin-bottom: 0;
  }
`;
export default {
    Wrapper,
};
